import moment from "moment";

export function getDeadline(dsar) {
  return moment(dsar.createdAt).add(15, "days").toDate();
}
